
/* injects from baggage-loader */

import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MatchOfTheDay from "../matchOfTheDay/index";
import { SwarmDataMixin } from "../../../../dev/mixins/swarmDataMixin";
import { getSwarmSubscriptionRequestPromotedGamesCount } from "../../../helpers/terminalRequests/promotedGames";
import Loader from "../loader";
import { createSelector } from "reselect";

class MatchOfTheDayWrapper extends Component {
	render() {
		if ((this.props.loaded && this.props.count) || this.props.showLiveGames) {
			return (
				<MatchOfTheDay
					count={this.props.count?.game}
					showLiveGames={this.props.showLiveGames}
				/>
			);
		} else {
			return <Loader component="matchOfTheDayWrapper" />;
		}
	}
}

MatchOfTheDayWrapper.propTypes = {
	loaded: PropTypes.bool,
	count: PropTypes.object,
	showLiveGames: PropTypes.bool,
};

const mapStateToProps = _ => {
	return createSelector(
		[
			state =>
				state.swarmData.data.promotedGameCount &&
				JSON.stringify(state.swarmData.data.promotedGameCount),
			state => state.swarmData.loaded.promotedGameCount,
		],
		(count, loaded) => {
			return {
				count: count && JSON.parse(count),
				loaded,
			};
		}
	);
};

export default connect(mapStateToProps)(
	SwarmDataMixin({
		Component: MatchOfTheDayWrapper,
		ComponentWillMount: function () {
			if (!this.props.showLiveGames) {
				this.swarmSubscriptionRequest = getSwarmSubscriptionRequestPromotedGamesCount();
				this.swarmDataKey = "promotedGameCount";
			}
		},
	})
);
